/**
 * GENERATED FILE — Spanish gender and plural lexicon. DO NOT EDIT BY HAND.
 *
 * Emitted by data-pipeline/run-romance.ts from the Wiktionary (wiktextract)
 * dump at kaikki.org. Data licence: CC BY-SA — see LICENSE-DATA.md.
 *
 * Only entries the rules get wrong are stored: gender where the ending
 * heuristic misleads (2736 of 58492 nouns), and plurals the
 * spelling rules do not produce (1345 of 48903).
 */

const GENDER_DATA = `abasida|m
abásida|m
abiogénesis|f
abivas|f
abreboca|m
absolutez|f
acantisita|m
acantosis|f
acaricida|m
acidez|f
acidosis|f
ácigos|f
acrocianosis|f
acrópolis|f
acrosoma|m
actinomicosis|f
actriz|f
addicion|f
adenitis|f
adenocarcinoma|m
adenohipófisis|f
adenoide|f
adenoma|m
adenomiosis|f
admón.|f
adoratriz|f
adultez|f
adulticida|m
adustez|f
advaita|m
aeda|m
aerobiosis|f
aerograma|m
aeronave|f
aeropirata|m
aerosinusitis|f
aerotrópolis|f
aeroyoga|m
afantasía|m
aféresis|f
afueras|f
aga|m
agallas|f
agastache|f
aglianico|f
agonista|m
agranulocitosis|f
agroecosistema|m
agruras|f
aguachirle|f
aguadulce|f
aguanieve|f
aguapá|f
aguaruna|m
agudez|f
aimara|m
airén|f
aita|m
akita|m
albricias|f
alcalosis|f
alcasínic|f
alción|m
ale|f
algidez|f
aliá|f
alienígena|m
alloza|m
alomadre|f
alostasis|f
alsa|m
álsine|f
altamar|f
altivez|f
alumbre|m
aluminosis|f
alveolar|f
alveolitis|f
alzacola|m
amá|f
amarilis|f
amarillez|f
amatxu|f
amaurosis|f
ambigrama|m
amebiasis|f
amigdalitis|f
amiloidosis|f
aminoacil|f
aminograma|m
amniocentesis|f
amniota|m
amonólisis|f
anaciclosis|f
anadiplosis|f
anafase|f
anafilaxis|f
anaforesis|f
anagnórisis|f
anagrama|m
anakinra|m
analema|m
analepsis|f
anamita|m
anamnesis|f
anamorfosis|f
anastilosis|f
anastomosis|f
anástrofe|f
anatema|m
anemone|f
aneurisma|m
anexión|f
anexitis|f
anfiartrosis|f
angarillas|f
angiitis|f
anginas|f
angiofibroma|m
angiogénesis|f
angiograma|m
angioma|m
angitis|f
anhidrasa|m
anhidrobiosis|f
anhidrosis|f
anisocitosis|f
anoxibiosis|f
anquilosis|f
anquilostoma|m
anteojera|m
anteojeras|f
antesis|f
antibiograma|m
anticresis|f
antífrasis|f
antinomianista|m
antipapa|m
antiparadigma|m
antiparras|f
antiprisma|m
antítesis|f
antracnosis|f
antracosis|f
apa|m
apendicitis|f
apocatástasis|f
apócope|f
apódosis|f
apófisis|f
aponeurosis|f
apoptosis|f
apotegma|m
apoteosis|f
apoteósis|f
apoyacabeza|m
apretazón|f
aproximante|f
aratinga|m
arbovirosis|f
archidiócesis|f
archieparca|m
archifonema|m
archimandrita|m
areopagita|m
argiráspida|m
argonauta|m
aridez|f
aroma|m
arquidiócesis|f
arras|f
arrenga|m
arterioesclerosis|f
arteriograma|m
arteriosclerosis|f
arteritis|f
artolas|f
artritis|f
artrocentesis|f
artrodesis|f
artrogriposis|f
artrosis|f
arzolla|m
asana|m
asbestosis|f
ascánida|m
ascesis|f
ascitis|f
ascoma|m
asentaderas|f
asheninka|m
asonante|f
aspergiloma|m
aspergilosis|f
astroblema|m
astrocitoma|m
astrol.|f
astronave|f
atacama|m
átame|f
ateroesclerosis|f
ateroma|m
aterosclerosis|f
atovaquona|m
atrabilis|f
atrijas|f
audiodrama|m
auriga|m
autocatálisis|f
autofagosoma|m
autofoto|f
autogestión|f
autohipnosis|f
autoimagen|f
autolisis|f
autómata|m
autoparte|f
autopatrulla|m
autorreflexión|f
autosoma|m
autostereograma|m
autosugestión|f
avatara|m
avda.|f
ave|f
avemaría|m
aventi|f
avidez|f
avilantez|f
axioma|m
axonema|m
axonotmesis|f
ayatola|m
aymara|m
ayudamemoria|m
ayuga|m
ayurveda|m
azañista|m
azumbre|m
babaylán|f
babirusa|m
bacanal|f
bacanería|m
bacanora|m
bactericida|m
badlands|f
baguet|f
baguete|f
baguette|f
bajamar|f
bajante|f
bajez|f
balanitis|f
balanopostitis|f
balatá|f
balboa|m
balonvolea|m
bambara|m
banga|m
bangla|m
barnabita|m
barotrauma|m
base|f
batuka|m
bazuka|m
bebezón|f
bechamel|f
beluga|m
bendi|f
beodez|f
beotarca|m
bequenpaura|m
besamel|f
bet|f
biblio|f
bici|f
bicúspide|f
bienal|f
bigdata|m
bilabial|f
bilis|f
bioanálisis|f
biocida|m
biocostra|m
biogénesis|f
bioma|m
biopesticida|m
bioplaguicida|m
biosíntesis|f
bipirámide|f
biplaza|m
biribilketa|m
birllas|f
birome|f
bisbita|m
bisectriz|f
bislama|m
bisoñez|f
bla|m
bla-bla|m
bla-bla-bla|m
blaxploitation|f
blefaritis|f
blockchain|f
blondie|m
boba|m
boca-oreja|m
bocacalle|f
bocajarro|f
bocallave|f
bocata|m
boîte|f
bolandista|m
bolivianita|m
boludez|f
bombogénesis|f
boogie|m
borgoña|m
botazón|f
bouchri|f
boutade|f
boutique|f
boyband|f
braguitas|f
bráhmana|m
brajá|f
brasiere|f
breverías|f
brie|m
brillantez|f
brocosoma|m
bronquiolitis|f
bronquitis|f
brownie|m
brucelosis|f
bruces|f
buda|m
buga|m
bugayo|f
bujarra|m
bullisto|f
burka|m
burqa|m
bursitis|f
c/|f
cabañuelas|f
cablegrama|m
cachaça|m
cachama|m
cachondez|f
caduquez|f
cagazón|f
cal|f
calendas|f
calidez|f
calientabraguetas|f
calientapijas|f
califa|m
caligrama|m
calle|f
camba|m
camionetota|m
canaimita|m
candidatitis|f
candidez|f
candidiasis|f
cantatriz|f
capanga|m
capibara|m
capicúa|m
capilaritis|f
capsulitis|f
caracara|m
carbuncosis|f
cárcel|f
carcinogénesis|f
carcinoma|m
carcinomatosis|f
cardiograma|m
cardiolipina|m
carditis|f
cargazón|f
cariátide|f
caries|f
cariñena|m
cariograma|m
carisma|m
carne|f
carnestolendas|f
carnitas|f
carrerista|m
cartograma|m
casanova|m
casolidá|f
caspicias|f
catábasis|f
catacresis|f
catálisis|f
catarsis|f
catástrofe|f
catedral|f
catequesis|f
catexis|f
causal|f
cavernoma|m
ce|f
cefa|m
celoma|m
celulitis|f
cenénquima|m
centinela|m
centro-derecha|m
centro-izquierda|m
centroderecha|m
centroizquierda|m
centrosoma|m
ceroidolipofuscinosis|f
cerrazón|f
cerve|f
cervicitis|f
cerviz|f
cetoacidosis|f
cetogénesis|f
cetosis|f
ceugma|m
cgd|f
cha|m
chacahuala|m
chacruna|m
chakra|m
chalación|m
chama|m
champaña|m
changana|m
chaparreras|f
chapas|f
charo|f
chati|f
chatría|m
chaufa|m
che|f
chemi|f
chepe|f
cheve|f
chicuela|m
chifa|m
chifita|m
chilaca|m
chimajá|f
chingamadral|f
chirilicas|f
chochez|f
cholgua|m
choni|f
choz|f
chulaputas|f
chuli|f
chuloplaya|m
chuminá|f
chupaderas|f
chupasavia|m
churre|f
cianogénesis|f
cianosis|f
ciboulette|f
cicatriz|f
ciclocalle|f
ciclogénesis|f
cicloide|f
ciclomorfosis|f
ciclorama|m
ciclotema|m
cifoescoliosis|f
cifosis|f
cigoma|m
cimofana|m
cinematografista|m
cinesis|f
cinetosis|f
circular|f
cirrosis|f
ciruja|m
cisma|m
cisticercosis|f
cistitis|f
cisuritis|f
citocinesis|f
citoplasma|m
citostoma|m
ciudad-estado|f
cladograma|m
clámide|f
claque|f
clase|f
clavazón|f
clave|f
clemátide|f
clima|m
climograma|m
cll|f
cloasma|m
clona|m
cloquez|f
clorosis|f
coala|m
cocapital|f
cocatedral|f
cocatriz|f
coccidioidomicosis|f
cochambre|f
cochebomba|m
cocombustión|f
cócora|m
codorniz|f
cofosis|f
cogestión|f
cohorte|f
coilocitosis|f
col|f
colab|f
colagenosis|f
colangiocarcinoma|m
colangitis|f
colapez|f
colecistitis|f
colelitiasis|f
colénquima|m
colestasis|f
colesteatoma|m
colesterolosis|f
coliflor|f
colilarga|m
colista|m
colitis|f
collie|m
coloboma|m
comadre|f
combersación|m
combustión|f
comezón|f
compa|m
complexión|f
complixión|f
comunión|f
concatedral|f
conchín|f
condiloma|m
condrocalcinosis|f
condroma|m
condromatosis|f
condrosarcoma|m
conectoma|m
conexión|f
confeccionista|m
confussion|f
congeries|f
congestión|f
conjuntivitis|f
conmutatriz|f
consonante|f
constante|f
contagión|f
contracorriente|f
contrafase|f
contralto|f
contraorden|f
contraparte|f
contrarreloj|f
contrarrelojista|m
contraruta|m
contratesis|f
contravía|m
convexión|f
coop|f
cópec|f
corambre|f
córdoba|m
cordoma|m
córeo|f
coriocarcinoma|m
coriomeningitis|f
cornaca|m
cornúpeta|m
coroides|f
coronal|f
corriente|f
cortagrama|m
cortahierba|m
coscas|f
cosecante|f
cosifa|m
cosmograma|m
cosmonave|f
cosmópolis|f
cosquillas|f
cotangente|f
cotinguita|m
coz|f
craneosinostosis|f
creces|f
credencial|f
crepidoma|m
cretinez|f
criazón|f
crin|f
crioesfinge|f
cripto|f
criptobiosis|f
criptofranco|f
criptograma|m
criptominero|f
criptorrublo|f
criptosistema|m
crisis|f
cristobita|m
croata|m
croma|m
cromatograma|m
cromista|m
cromosoma|m
cromotripsis|f
cronismo|f
cronograma|m
cronostasis|f
crucifixión|f
crucigrama|m
cruz|f
cu|f
cúa|m
cuadrántidas|f
cuadratriz|f
cuara|m
cuarentas|f
cuatrimoto|f
cubata|m
cubreboca|m
cubrecama|m
cubretetera|m
cuchar|f
cuchubal|f
cuestión|f
cuma|m
cumplesanto|f
curaca|m
curie|m
curtiembre|f
curtosis|f
cúspide|f
cutrez|f
dacriocistitis|f
dactilitis|f
dactilograma|m
dálet|f
dálmata|m
damajagua|m
damas|f
dantonista|m
darma|m
datagrama|m
dcha.|f
de|f
debacle|f
decadentista|m
declaracionitis|f
deflexión|f
deíxis|f
dejadez|f
delgadez|f
delicadez|f
delicatessen|f
demonial|f
dendrograma|m
denticidad|m
dentinogénesis|f
depa|m
deplexión|f
depre|f
dermatitis|f
dermatofitosis|f
dermatomiositis|f
dermatosis|f
dermis|f
dermitis|f
desanexión|f
desazón|f
descalcez|f
descomunización|m
desconexión|f
descongestión|f
desfacción|m
desfachatez|f
deslumbre|m
desmosoma|m
desnudez|f
desoxiazúcar|f
despabiladeras|f
desunión|f
détox|f
dia|m
día|m
diabetes|f
diábetes|f
diáfisis|f
diaforesis|f
diafragma|m
diagénesis|f
diagnosis|f
diagonal|f
diagrama|m
diálisis|f
diapédesis|f
diapo|f
diapófisis|f
diaporama|m
diarca|m
diartrosis|f
diasistema|m
diástole|f
diátesis|f
dictioma|m
dictiosoma|m
diégesis|f
diéresis|f
digestión|f
digital|f
diguanilato|f
diíta|m
dilema|m
dinacharya|m
diócesis|f
diorama|m
dipeptidil|f
diploma|m
diplómata|m
diplosoma|m
direccional|f
directriz|f
disbiosis|f
discitis|f
discoteque|f
diuresis|f
diverticulitis|f
diverticulosis|f
dixie|m
doceañista|m
docudrama|m
dodecápolis|f
dogma|m
dominatrix|f
dominatriz|f
doncellez|f
dorama|m
dorsiflexión|f
dosis|f
dote|f
dracónidas|f
drama|m
dramita|m
dríade|f
druida|m
dudka|m
duramadre|f
e|f
ebanista|m
ebitda|m
ébola|m
eccema|m
écfrasis|f
echazón|f
ecocardiograma|m
ecomorfosis|f
ecorregión|f
ecosistema|m
ecosonograma|m
éctasis|f
ectima|m
ectoplasma|m
ecúmene|f
eczema|m
edema|m
efe|f
efeméride|f
efemérides|f
egestión|f
ehriliquosis|f
ehrlichiosis|f
elamita|m
ele|f
electriz|f
electrocardiograma|m
electroencefalograma|m
electroforesis|f
electrolisis|f
electrólisis|f
electromiograma|m
electroretinograma|m
elefantiasis|f
elementalista|m
eleosoma|m
elipse|f
elipsis|f
elite|f
élite|f
elle|f
emblema|m
embriaguez|f
embriogénesis|f
eme|f
emesis|f
emperatriz|f
empiema|m
empollamiento|f
empresariales|f
emungente|f
enartrosis|f
encefalitis|f
encefalograma|m
encefalomielitis|f
encondroma|m
encondromatosis|f
encopresis|f
encueratriz|f
endeblez|f
endíadis|f
endocarditis|f
endocitosis|f
endometrioma|m
endometriosis|f
endometritis|f
endoprótesis|f
endosimbiosis|f
endosoma|m
endosperma|m
ene|f
eñe|f
eneagrama|m
enebeísta|m
enema|m
enfisema|m
enfiteusis|f
engordacabra|m
engrama|m
enigma|m
enjambrazón|f
enjutez|f
enosis|f
éntasis|f
entendederas|f
entente|f
enteritis|f
enterobiasis|f
enterocolitis|f
entesis|f
entesitis|f
entimema|m
entorsis|f
entrecajas|f
entrecalle|f
entreguerras|f
enuresis|f
envolvente|f
eonotema|m
epanadiplosis|f
epanalepsis|f
ependimoma|m
epéntesis|f
epíbata|m
epicicloide|f
epíclesis|f
epicondilitis|f
epicrisis|f
epidermis|f
epidermólisis|f
epididimitis|f
epidural|f
epifaringe|f
epifisiolisis|f
epifisiólisis|f
epífisis|f
epifonema|m
epífrasis|f
epigénesis|f
epiglotis|f
epigrama|m
epigramista|m
epileptogénesis|f
epipófisis|f
epístata|m
epistaxis|f
episteme|f
epítesis|f
épsilon|f
equidna|m
equimosis|f
equis|f
eratema|m
ere|f
eritema|m
eritropoyesis|f
erre|f
esbeltez|f
escabiosis|f
escasez|f
esclerénquima|m
escleritis|f
esclerosis|f
escolarca|m
escoliosis|f
escondidas|f
escotoma|m
escriba|m
escualidez|f
escuelacitis|f
escurra|m
ese|f
esfenodonto|f
esferocitosis|f
esfinge|f
esmegma|m
esofagitis|f
espantabrujas|f
espantaviejos|f
espectrograma|m
espeleotema|m
espermátide|f
espermatogénesis|f
espermicida|m
espermiogénesis|f
espiral|f
espiramicina|m
esplendidez|f
esplenitis|f
espliceosoma|m
espondilitis|f
espondilodiscitis|f
espondilolistesis|f
espondilosis|f
espongiosis|f
esporoplasma|m
esposas|f
espumuy|f
esquema|m
esquijama|m
esquistosomiasis|f
esquivez|f
estadity|f
estafiloma|m
estasis|f
esteatohepatitis|f
esteatosis|f
estenosis|f
estereograma|m
estereopsis|f
esterigma|m
estigma|m
estilema|m
estilita|m
estíquer|f
estirpe|f
estoma|m
estomatitis|f
estrechez|f
estroma|m
estrongiloidiasis|f
estupidez|f
etcétera|m
eteochipriota|m
etnogénesis|f
eucatástrofe|f
eurodrama|m
euroorden|f
euskara|m
euskera|m
eusquera|m
exactriz|f
exantema|m
exarca|m
exazulgrana|m
excomunión|f
excura|m
exegesis|f
exégesis|f
exequias|f
exéresis|f
exfilial|f
exilarca|m
exmiss|f
exmujer|f
exocitosis|f
exocometa|m
exoma|m
exoplaneta|m
exosoma|m
expensas|f
expertise|f
explaneta|m
expo|f
exquisitez|f
exselección|m
exsindicalista|m
exterminal|f
extrañez|f
extrasístole|f
fa|m
face|f
facies|f
facu|f
fagocitosis|f
fagosoma|m
falange|f
fambre|f
fame|f
fanpage|f
fantasma|m
farfalle|f
faringe|f
faringitis|f
faringoamigdalitis|f
fascitis|f
fase|f
fauce|f
faz|f
fe|f
fé|f
feca|m
fecaloma|m
fedora|m
felatriz|f
feocromocitoma|m
fetén|f
fetidez|f
fi|f
fibrinolisis|f
fibrinólisis|f
fibroblastoma|m
fibrocondrogénesis|f
fibroelastosis|f
fibroma|m
fibrosis|f
fibroxantoma|m
fideuá|f
fiebre|f
filarca|m
filariasis|f
filogénesis|f
filograma|m
filosofema|m
filotaxis|f
fimosis|f
fisio|f
fitoplasma|m
flaccidez|f
flacidez|f
flebitis|f
flexión|f
floema|m
flogosis|f
flor|f
floreana|m
fludrocortisona|m
fluidez|f
fluxión|f
foie|m
foliculitis|f
folkie|m
fonavista|m
fondue|f
fonema|m
fonograma|m
foquista|m
fotico|f
fotito|f
foto|f
fotocatálisis|f
fotocorriente|f
fotograma|m
fotólisis|f
fotomorfogénesis|f
fotopene|f
fotosíntesis|f
fotosistema|m
fototaxis|f
fragmosis|f
frase|f
freatofita|m
frenetismo|f
frigidez|f
friz|f
frondicismo|f
frónesis|f
fronte|f
frontwoman|f
fucosa|m
fuente|f
fukú|f
fula|m
fulita|m
fungicida|m
furgo|f
furtivista|m
futanari|f
futsala|m
gachas|f
gachí|f
gafas|f
gallinejas|f
gametogénesis|f
ganas|f
ganitas|f
ganjifa|m
garganega|m
gastritis|f
gastroenteritis|f
gastrosquisis|f
ge|f
gelada|m
gelidez|f
gemínidas|f
genearca|m
generalitat|f
generatriz|f
génesis|f
genoma|m
gens|f
gente|f
genuflexión|f
geoduck|f
geoeconomista|m
georregión|f
germicida|m
germoplasma|m
gestante|f
gestión|f
giardiasis|f
gigantez|f
gilipolla|m
gilipollez|f
gillette|f
gingivectomía|m
gingivitis|f
glagolitsa|m
glásnost|f
glaucoma|m
glicocálix|f
glicólisis|f
glioblastoma|m
glioma|m
glioxisoma|m
glomeruloesclerosis|f
glomerulonefritis|f
glotis|f
glucagonoma|m
glucocáliz|f
glucogenólisis|f
glucogenosis|f
glucólisis|f
gluconeogénesis|f
gnatostomiasis|f
gnosis|f
godolandia|m
golden|f
golpista|m
gomía|m
gonartrosis|f
gorila|m
gouda|m
goya|m
gracias|f
grafema|m
grafiosis|f
grandeliga|m
granuloma|m
granulomatosis|f
granulopoyesis|f
gravidez|f
grey|f
grignolino|f
gripe|f
guairista|m
guaraniná|f
guardabarranca|m
guardacaza|m
guardamarina|m
guardapesca|m
guardapizza|m
guardarropa|m
guardatinaja|m
guardavía|m
guardiamarina|m
guardiolista|m
gudugudu|f
guímel|f
guloya|m
hache|f
haecceitas|f
haida|m
haiga|m
halajá|f
halitosis|f
hamamelis|f
hamartoma|m
hambre|f
hanta|m
hasanía|m
hashitoxicosis|f
hassaniya|m
hausa|m
hb|f
he|f
hecatombe|f
hedenbergita|m
hediondez|f
hélice|f
helicotrema|m
helmintiasis|f
hemangioma|m
hemangiosarcoma|m
hematemesis|f
hematoma|m
hematopoyesis|f
hemivida|m
hemocromatosis|f
hemodiálisis|f
hemograma|m
hemolisis|f
hemólisis|f
hemopoyesis|f
hemoptisis|f
hemorroide|f
hemorroides|f
hendíadis|f
hepatitis|f
hepatocarcinoma|m
heptagrama|m
herbicida|m
heredosífilis|f
herma|m
hermafrodita|m
herriko|f
heterocigosis|f
heterounión|f
hexagrama|m
hez|f
hibridez|f
hidatidosis|f
hideputa|m
hidroclorotiazida|m
hidrogenólisis|f
hidrogenosoma|m
hidrograma|m
hidrolisis|f
hidrólisis|f
hidronefrosis|f
hiebre|f
hiel|f
hieracoesfinge|f
hierbahuerto|f
hierofanta|m
hifoloma|m
higiene|f
hijadalgo|f
hijoputa|m
hijueputa|m
hijueputez|f
hijueputilla|m
himalayista|m
hinchazón|f
hipálage|f
hipaspista|m
hipema|m
hiperacidez|f
hiperconexión|f
hiperémesis|f
hipergigante|f
hiperhidrosis|f
hiperlordosis|f
hipermetamorfosis|f
hiperostosis|f
hiperqueratosis|f
hipertermoplaneta|m
hipertricosis|f
hipervitaminosis|f
hipnosis|f
hipocicloide|f
hipodermis|f
hipofaringe|f
hipófisis|f
hipopsicroplaneta|m
hipóstasis|f
hipostoma|m
hipótesi|f
hipótesis|f
hipotrocoide|f
hipovitaminosis|f
histéresis|f
histiocitosis|f
histograma|m
hitita|m
hna.|f
hologenoma|m
holograma|m
homeoestasis|f
homeostasis|f
homocigosis|f
honradez|f
hopia|m
hoplita|m
horeca|m
hortofruticultura|m
hoz|f
huambra|m
hubris|f
hueá|f
hueste|f
huevá|f
huinca|m
huishlla|m
hula-hula|m
hulahúla|m
hurí|f
hybris|f
i|f
ictiosis|f
ideograma|m
idioma|m
idiotez|f
idomia|m
idosa|m
igualá|f
iliquidez|f
ilu|f
imagen|f
imaginista|m
impavidez|f
impro|f
incha|m
indicatriz|f
indie|m
indigestión|f
indoescita|m
índole|f
indometacina|m
inelipse|f
inflexión|f
info|f
infraclase|f
ingestión|f
ingle|f
ingravidez|f
inicial|f
inmadurez|f
inmediatez|f
inmunoprofilaxis|f
insecticida|m
insensatez|f
insercionitis|f
insipidez|f
institutriz|f
insulinoma|m
insulsez|f
integral|f
interconexión|f
interfase|f
interfaz|f
interferograma|m
interred|f
intranet|f
intrepidez|f
intro|f
invalidez|f
invariante|f
inventriz|f
ióyana|m
ípsilon|f
ironista|m
irreflexión|f
irreligión|f
isapre|f
isocromosoma|m
itonama|m
izq|f
jalá|f
jalifa|m
jandilla|m
januquiá|f
jaredita|m
jartá|f
jermu|f
ji|f
jicarilla|m
jisra|m
joputa|m
jorobeta|m
jotraba|m
juela|m
jueputa|m
juju|f
jula|m
jupá|f
karma|m
kendama|m
kerigma|m
kermés|f
kichwa|m
kill|f
kimbanda|m
kipá|f
kisomba|m
koala|m
koiné|f
kópek|f
kullawada|m
la|m
laberintitis|f
labial|f
labiodental|f
labor|f
lady|f
laika|m
lande|f
landre|f
languidez|f
lanzabengalas|f
laringal|f
laringe|f
laringitis|f
larvicida|m
laudatio|f
laude|f
lavarropa|m
leberwurst|f
leche|f
legión|f
legionelosis|f
leiomioma|m
leishmaniasis|f
leishmaniosis|f
lema|m
lempira|m
leónidas|f
leptospirosis|f
lerdista|m
leucocitosis|f
leucoencefalitis|f
lexema|m
ley|f
libídine|f
libido|f
lid|f
liebre|f
liendre|f
ligamayorista|m
ligamenorista|m
ligazón|f
ligerez|f
limpidez|f
linfadenitis|f
linfangioleiomiomatosis|f
linfangitis|f
linfedema|m
linfocitosis|f
linfoma|m
linfopoyesis|f
linfotoxina|m
lipograma|m
lipolisis|f
lipólisis|f
lipoma|m
liposarcoma|m
liposoma|m
liqueribá|f
liquidez|f
líridas|f
lis|f
lisis|f
lisosoma|m
listeriosis|f
litiasis|f
litis|f
litote|f
lítote|f
litotes|f
lítotes|f
lividez|f
llave|f
llerista|m
llobaca|m
lluviecita|m
lobreguez|f
logograma|m
lombriz|f
lordosis|f
luau|f
lucidez|f
lución|m
lumi|f
lumpia|m
lumpiá|f
lunfa|m
luvita|m
luz|f
machinima|m
macis|f
macroadenoma|m
macrocitosis|f
macrorregión|f
macrosistema|m
macrourbe|f
madame|f
madre|f
madurez|f
maestrescuela|m
mafufada|m
magenta|m
magma|m
mágnum|f
mahagua|m
mahayana|m
mai|f
maid|f
maison|f
majás|f
malamadre|f
malasangre|f
malcoha|m
malcriadez|f
malinche|f
mallorquinista|m
mamá|f
mamatón|f
mami|f
mamitis|f
manaca|m
manaje|f
mancebez|f
mandala|m
manhua|m
manhwa|m
mani|f
mantis|f
mantra|m
manuantara|m
maoísta|m
mapa|m
mapanare|f
marcen|f
marchitez|f
mariliendre|f
marimacho|f
marista|m
márjen|f
marrocas|f
masacre|f
masacuata|m
mascá|f
mascletá|f
masculinista|m
masoreta|m
mastitis|f
mastocitoma|m
matagalpa|m
matatenas|f
matazón|f
matemáticas|f
mates|f
matidez|f
matiné|f
matrioska|m
matriz|f
mecanosíntesis|f
medianoche|f
medias|f
mediastinitis|f
mediatriz|f
mediodia|m
mediodía|m
meduloepitelioma|m
megacontrato|f
megacrisis|f
megalógrafo|f
megalópolis|f
megarregión|f
megaurbe|f
meiosis|f
melanoma|m
melanosoma|m
melasma|m
melé|f
melée|f
mêlée|f
melisma|m
melodrama|m
memez|f
ménade|f
menda|m
menestrón|f
meninge|f
meningioma|m
meningitis|f
meningoencefalitis|f
mennonita|m
menorá|f
mente|f
merced|f
merçed|f
merengón|f
meretriz|f
meristema|m
mersa|m
mesénquima|m
mesofase|f
mesoplaneta|m
mesorregión|f
mesotelioma|m
metábasis|f
metaboloma|m
metafase|f
metáfisis|f
metagenoma|m
metalurgista|m
metamorfosis|f
metanogénesis|f
metaparadigma|m
metasoma|m
metástasis|f
metátesis|f
metaxilema|m
metempsicosis|f
metesaca|m
metformina|m
metiletilcetona|m
metisaca|m
metritis|f
metrópoli|f
metrópolis|f
mezuzá|f
mezzosoprano|f
mi3rd@|f
miasis|f
miasma|m
micosis|f
microanálisis|f
microbicida|m
microbioma|m
microclima|m
microdosis|f
microgestión|f
micromatriz|f
microprograma|m
micropyme|f
microrregión|f
microsistema|m
microsporogénesis|f
midriasis|f
miel|f
mielitis|f
mielofibrosis|f
mieloma|m
mielopoyesis|f
miente|f
mies|f
migajas|f
milenita|m
mili|f
milipili|f
mimesis|f
mímesis|f
minarquía|m
minestrone|f
minicalle|f
minicentral|f
minidosis|f
minimapa|m
minimosca|m
minipimer|f
minorita|m
miocarditis|f
miograma|m
mioma|m
mionca|m
miopericarditis|f
miosis|f
miositis|f
misiá|f
misis|f
miss|f
mitema|m
mitosis|f
mitzvá|f
miura|m
mixogénesis|f
mixoma|m
mixomatosis|f
mmd|f
modernez|f
mojadez|f
moka|m
moksha|m
mollez|f
molusquicida|m
mondá|f
monema|m
monoartritis|f
monodosis|f
monogénesis|f
monograma|m
mononucleosis|f
monoplaza|m
monopoyesis|f
monotema|m
monotrema|m
morbidez|f
morcipán|f
morfema|m
morfogénesis|f
morfosintaxis|f
morgue|f
mortual|f
motillo|f
motonave|f
motonieve|f
mousse|f
moxibustión|f
mrd|f
mu|f
mucopolisacaridosis|f
mucormicosis|f
mucositis|f
mucoviscidosis|f
mudez|f
mudra|m
mueblista|m
muerte|f
muger|f
mugre|f
mujer|f
mulcédine|f
múleo|f
muléolo|f
multi|f
multiaventura|m
multinacional|f
multiplexión|f
múrice|f
musicograma|m
mutagénesis|f
muzza|m
ñacañaca|m
nanosistema|m
nao|f
napias|f
narcomanta|m
nariz|f
nasal|f
nasua|m
nave|f
náyade|f
necrólisis|f
necrópolis|f
necrosis|f
nefritis|f
nefroesclerosis|f
nefroide|f
nefrolitiasis|f
nefrosclerosis|f
nefrosis|f
nematicida|m
némesis|f
neocentralista|m
neoecosistema|m
neoplasticista|m
net|f
neuma|m
neumoconiosis|f
neumonitis|f
neurilemoma|m
neurinoma|m
neuritis|f
neurocisticercosis|f
neurodermatitis|f
neurodermitis|f
neurofibromatosis|f
neurogénesis|f
neurohipófisis|f
neuroimagen|f
neuroma|m
neuromielitis|f
neuroprótesis|f
neurosífilis|f
neurosis|f
neurotmesis|f
nevazón|f
ñeve|f
nguemista|m
ni|f
nieve|f
niñez|f
nirvana|m
nitidez|f
ñoba|m
nocardiosis|f
noche|f
nomarca|m
nomograma|m
normal|f
notición|m
noviecilla|m
nubazón|f
nube|f
nucleocápside|f
nucleoplasma|m
nucleosíntesis|f
nucleosoma|m
nude|f
nuez|f
numisma|m
nupcias|f
nutella|m
ny|f
o|f
obianguemista|m
oceánide|f
ocra|m
oenegé|f
offshore|f
ofi|f
oligoartritis|f
oligodendroglioma|m
ombroclima|m
omeya|m
ómicron|f
oñatiarra|m
once|f
oncocercosis|f
oncodermatitis|f
oncogénesis|f
onicomicosis|f
onicosis|f
ontogénesis|f
opinión|f
opistosoma|m
opos|f
ordinariez|f
oréade|f
organigrama|m
organogénesis|f
oricha|m
oriónidas|f
orisha|m
orofaringe|f
orogénesis|f
orquitis|f
ortesis|f
ortogénesis|f
ortomitosis|f
ortosis|f
oseta|m
oshá|f
ósmosis|f
osteítis|f
osteoartritis|f
osteoartrosis|f
osteocondritis|f
osteocondrosis|f
osteogénesis|f
osteomielitis|f
osteonecrosis|f
osteopetrosis|f
osteoporosis|f
osteosarcoma|m
osteosíntesis|f
otitis|f
otoesclerosis|f
otohematoma|m
otosclerosis|f
ovicida|m
ovogénesis|f
ozonólisis|f
p.|f
pa|m
pacamara|m
pader|f
pág|f
pagua|m
paisa|m
palametograma|m
palatal|f
palavolo|f
paleoclima|m
palidez|f
palude|f
panarra|m
pancreatitis|f
pangrama|m
pañí|f
paniculitis|f
panorama|m
pantaletas|f
pantumaca|m
papaja|m
papayuela|m
paperas|f
papiloma|m
papitis|f
para|m
parábasis|f
parabiosis|f
paracistitis|f
paradigma|m
paraestatal|f
parafimosis|f
paráfisis|f
paráfrasis|f
paragénesis|f
paragoge|f
paragua|m
paragüita|m
paralipsis|f
parálisis|f
parapófisis|f
parasíntesis|f
parasistema|m
parasitosis|f
paratiroide|f
parato|f
pared|f
parénesis|f
parénquima|m
parentosoma|m
parisienne|f
parodista|m
parotiditis|f
partenogénesis|f
partes|f
parturiente|f
parvulez|f
pasaboca|m
pasamontaña|m
pastoral|f
patatillas|f
patente|f
patogénesis|f
patovica|m
patriarca|m
patrilinealidad|m
patronal|f
patudez|f
pavarreal|f
paz|f
pe|f
pecatriz|f
pechá|f
pedegista|m
pediculosis|f
pedomorfosis|f
pelazón|f
peli|f
pelotudez|f
pelu|f
pelvis|f
pendejez|f
pentagrama|m
pentaprisma|m
peoneta|m
pequeñez|f
perdiz|f
perfo|f
perfomance|f
pericardiocentesis|f
pericarditis|f
pericondritis|f
perífrasis|f
periodontitis|f
periostosis|f
periplasma|m
peristalsis|f
peritonitis|f
permanente|f
peroxisoma|m
persa|m
perseidas|f
pertusis|f
pertussis|f
pesadez|f
pesoca|m
pestañí|f
peste|f
pesticida|m
petazeta|m
petisuis|f
petrogénesis|f
pi|f
picas|f
picazón|f
picazuró|f
pichabrava|m
picnosis|f
picocuña|m
picoguadaña|m
picolezna|m
pictograma|m
pie|m
piedralipe|f
piel|f
pielonefritis|f
pifie|m
pilsen|f
pinocitosis|f
pioderma|m
pioneta|m
piramidal|f
pirámide|f
pirólisis|f
piroquinesis|f
pirosis|f
pitayo|f
pitiosis|f
pitiriasis|f
píxide|f
pixidio|f
pizarrista|m
placidez|f
plaguicida|m
planeta|m
planetita|m
plasma|m
plasmaféresis|f
platillito|f
platisma|m
platonista|m
playlist|f
pleamar|f
plebe|f
pleocitosis|f
pléroma|m
pléyade|f
pneuma|m
poblazón|f
pocra|m
podre|f
podredura|m
poema|m
poemita|m
polaroid|f
poleá|f
polemarca|m
poleta|m
poli|f
poliangeítis|f
poliartritis|f
policontusiones|f
poligénesis|f
polimiositis|f
polineuritis|f
polinosis|f
polio|f
poliomielitis|f
poliposis|f
poliptoton|f
políptoton|f
poliquistosis|f
polis|f
polisomnograma|m
politrauma|m
pollavieja|m
pómez|f
ponja|m
popola|m
porisma|m
poroqueratosis|f
porta-goma|m
poscombustión|f
pose|f
postal|f
postcombustión|f
postrimerías|f
potaxie|m
poti|f
potideata|m
poule|f
pragma|m
prana|m
praxis|f
preantesis|f
precombustión|f
prediabetes|f
prediálisis|f
preimagen|f
prelefa|m
prematurez|f
premiere|f
preñez|f
pretroncal|f
preventa|m
prezigapófisis|f
primarias|f
pringá|f
prisma|m
problema|m
problemilla|m
problemita|m
probóscide|f
procariota|m
procatedral|f
procu|f
prof.ᵃ|f
profase|f
profeta|m
profilaxis|f
proglótide|f
prognosis|f
programa|m
programita|m
prole|f
prolepsis|f
prometafase|f
promo|f
propi|f
prosénquima|m
prosoma|m
prostatitis|f
prótasis|f
proteasoma|m
protectriz|f
proteinograma|m
proteolisis|f
proteólisis|f
proteoma|m
proteosoma|m
prótesis|f
protista|m
protodermis|f
protoelamita|m
protoeuskera|m
protofonema|m
protoplaneta|m
protoplasma|m
protoquechua|m
protoxilema|m
psamoma|m
pseudoaneurisma|m
pseudoartrosis|f
pseudoceloma|m
pseudoclase|f
pseudohermafrodita|m
pseudomorfosis|f
psi|f
psicodrama|m
psicogénesis|f
psiconeurosis|f
psicoquinesis|f
psicosis|f
psicostasis|f
psicroplaneta|m
psique|f
psiquis|f
psoriasis|f
pterostigma|m
ptosis|f
publi|f
pucara|m
pudibundez|f
pulg|f
puma|m
puñalá|f
puntocom|f
puquina|m
purana|m
purépecha|m
pusi|f
pyme|f
qualy|f
quechua|m
quemagrasa|m
quemazón|f
quemosis|f
quenya|m
queratitis|f
queratoconjuntivitis|f
queratosis|f
quermés|f
quiasma|m
quiebraplata|m
quiete|f
quiliarca|m
quimio|f
quimioprofilaxis|f
quimiosíntesis|f
quimiosmosis|f
quimiotaxis|f
quinoleína|m
quinolina|m
quitamaridos|f
quitridiomicosis|f
rabdomiolisis|f
rabdomiólisis|f
rabdomiosarcoma|m
raclette|f
radiobase|f
radiodrama|m
radiofoto|f
radiofuente|f
radiofusora|m
radiograma|m
radiolisis|f
radiopatrulla|m
raigambre|f
raíz|f
rajaleña|m
ramazón|f
rapidez|f
raquitis|f
rastas|f
raticida|m
ratite|f
razón|f
realme|f
reanexión|f
rebalsa|m
rebelión|f
reconexión|f
recortada|m
red|f
redila|m
redondez|f
reestenosis|f
refección|m
réflex|f
reflexión|f
regañá|f
región|f
religión|f
rema|m
rendsina|m
rene|f
reotaxis|f
repe|f
repentinitis|f
repentitis|f
res|f
resíntesis|f
reticulocitosis|f
retinitis|f
retinoblastoma|m
retinosis|f
retroflexión|f
retrolistesis|f
retrosíntesis|f
reuma|m
reúma|m
reunión|f
reventazón|f
rho|f
ribosoma|m
ribozimas|f
rickettsiosis|f
ridiculez|f
rigidez|f
rinitis|f
rinoconjuntivitis|f
rinofaringe|f
rioba|m
rioja|m
rispidez|f
ritidoma|m
rituximab|f
rizartrosis|f
rizoma|m
ro|f
robamaridos|f
robustez|f
rodenticida|m
rojez|f
ronquez|f
rotundez|f
roturita|m
rubicundez|f
rudista|m
ruedamierda|m
rumazón|f
sabritas|f
sacapunta|m
sacroilitis|f
sagarmín|f
saiga|m
sal|f
salabat|f
salazón|f
salchipán|f
salmonelosis|f
saltacuerda|m
salud|f
salvavida|m
salvequeada|m
sampi|f
samsara|m
sandez|f
sangre|f
sansara|m
sapidez|f
sarasa|m
sarcocistosis|f
sarcoidosis|f
sarcolema|m
sarcoma|m
sarcoplasma|m
sardónice|f
sardónix|f
sátrapa|m
saudade|f
sazón|f
schwannoma|m
seccional|f
sed|f
sede|f
sele|f
sema|m
semantema|m
semi|f
semiconsonante|f
semidesnudez|f
semifinal|f
semillón|f
seminoma|m
semioruga|m
semirraya|m
semivocal|f
señá|f
señal|f
sencillez|f
seño|f
sensatez|f
seo|f
sepsis|f
septembrista|m
serbocroata|m
serpiente|f
sesentas|f
sesudez|f
setentonas|f
sexteta|m
shamoji|f
shawarma|m
shejiná|f
shigelosis|f
shikse|f
sibarita|m
sibilante|f
sicav|f
sicosis|f
sida|m
sien|f
sierpe|f
sifaca|m
sífilis|f
silabograma|m
silbante|f
silepsis|f
sílfide|f
sílice|f
silicosis|f
simba|m
simbiogénesis|f
simbiosis|f
simiente|f
sinapsis|f
sinaptogénesis|f
sinartrosis|f
sincondrosis|f
sindéresis|f
sinécdoque|f
sinéresis|f
sinfibrosis|f
sínfisis|f
sinograma|m
sinopsis|f
sinostosis|f
sinovitis|f
sinpa|m
sinrazón|f
sintagma|m
sintaxis|f
síntesis|f
síntoma|m
sinusitis|f
sinusoide|f
siringe|f
sirte|f
sismograma|m
sistema|m
sístole|f
ska|m
skin|f
skúa|m
smoothie|m
sobreceja|m
sobrecorriente|f
sobredosis|f
sobrefaz|f
sobrepelliz|f
socimi|f
sociodrama|m
sociogénesis|f
sociograma|m
sociokuéra|m
sodomita|m
sofisma|m
sokamuturra|m
solfa|m
solidez|f
somatón|f
sonograma|m
sopista|m
soplapollez|f
sor|f
sordidez|f
soubise|f
spa|m
startup|f
stout|f
subálgebra|m
subanálisis|f
subclase|f
subclave|f
subdominante|f
subependimoma|m
subfase|f
subibaja|m
subjetivista|m
sublema|m
submatriz|f
subparte|f
subportátil|f
subproblema|m
subprograma|m
subrasante|f
subred|f
subregión|f
subsede|f
subseñal|f
subsistema|m
subtema|m
subtribu|f
subvariante|f
subvertiente|f
sucursal|f
suerte|f
sugestión|f
suimanga|m
suite|f
sulfosal|f
sumativo|f
sumerograma|m
sunorma|m
superactriz|f
superclase|f
superfinal|f
superfluidez|f
superfoto|f
supergigante|f
supermamá|f
supermujer|f
supertribu|f
sura|m
suricata|m
tablaestela|m
tabuyayá|f
tacataca|m
tagma|m
tahuarí|f
taita|m
taja|m
talope|f
tangente|f
tantra|m
tapaboca|m
tarde|f
tarde-noche|f
tartamudez|f
táuridas|f
taxirruta|m
te|f
tele|f
teleclase|f
telegrama|m
telégrama|m
telequinesis|f
telesalud|f
telesilla|m
telosoma|m
tema|m
temita|m
témporas|f
tenazas|f
tendinitis|f
tendota|m
tenosinovitis|f
teobroma|m
teorema|m
tepehua|m
teratogénesis|f
teratoma|m
termas|f
termoforesis|f
termogénesis|f
termólisis|f
termoplaneta|m
terranova|m
tesis|f
testarudez|f
tetragrama|m
tevé|f
tez|f
tigriña|m
tikuna|m
timagua|m
timeline|f
timidez|f
timucua|m
tincho|f
tiqui-taca|m
tirantez|f
tiroiditis|f
tirotoxicosis|f
tisis|f
titánide|f
titi|f
titulitis|f
tmesis|f
tnuá|f
tocacinta|m
tofi|f
tomboy|f
tontolaba|m
tontolava|m
topogigio|f
topoyiyo|f
toquegua|m
torcaz|f
torques|f
torre|f
tortícolis|f
tos|f
totorota|m
toxoplasmosis|f
tozudez|f
trabazón|f
tracoma|m
tragaderas|f
trágala|m
tragamoneda|m
tragaperras|f
tramititis|f
tranita|m
transcitosis|f
transcriptoma|m
transgénesis|f
translucidez|f
transnacional|f
transversal|f
tranvía|m
traqueítis|f
traqueobronquitis|f
trascoda|m
trastuzumab|f
trauma|m
travesti|f
trebbiano|f
trechor|f
treintista|m
treosa|m
tríade|f
triarca|m
tribu|f
tricoma|m
tricomoniasis|f
trigrama|m
triholósido|f
trilema|m
tripanosoma|m
tripanosomiasis|f
triquiasis|f
triquinosis|f
trocoide|f
trogocitosis|f
troj|f
troje|f
trombocitosis|f
tromboflebitis|f
trombogénesis|f
trombolisis|f
trombopoyesis|f
trombosis|f
trompista|m
troskista|m
trotskista|m
troupe|f
trox|f
tsonga|m
tuberculosis|f
tubícola|m
tupidez|f
turbidez|f
tutriz|f
tuya-mía|m
tv|f
u|f
ubi|f
ubre|f
ula-ula|m
ulema|m
ulti|f
ultrafeminista|m
umrah|f
uncial|f
uni|f
unidosis|f
unión|f
upanishada|m
uranista|m
urbe|f
urdimbre|f
uretritis|f
urolitiasis|f
úrsidas|f
usucapión|f
uve|f
uveítis|f
v4cun4|f
vacante|f
vaciante|f
vaginitis|f
vaginosis|f
validez|f
variable|f
variante|f
varice|f
várice|f
variedades|f
variograma|m
variz|f
vasculitis|f
vav|f
vdd|f
ve|f
vedete|f
vedette|f
vejez|f
velatón|f
velouté|f
veras|f
verbigracia|m
verde-oliva|m
verriondez|f
vertical|f
verticilosis|f
vertiente|f
vestal|f
veste|f
vestición|m
vetustez|f
vez|f
vg|f
vibrante|f
vicetiple|f
victrola|m
vid|f
videodanza|m
videograma|m
vietnamita|m
vigía|m
virosis|f
vitro|f
viudez|f
vivez|f
vocal|f
vodca|m
vodka|m
voivoda|m
volea|m
vóley-playa|m
vorágine|f
voxista|m
voz|f
vrd|f
vrg|f
vulvovaginitis|f
waifu|f
walkie-talkie|m
waripola|m
wbd|f
weá|f
webcam|f
webdrama|m
wiphala|m
wookie|m
xantana|m
xantogranuloma|m
xantoma|m
xantomatosis|f
xi|f
xícara|m
xilema|m
xinca|m
yarará|f
yasmiande|f
yayoflauta|m
ye|f
yeshivá|f
yihad|f
yiyi|f
yobaca|m
yod|f
yoga|m
yorkie|m
yoruba|m
yoyega|m
yugular|f
yungas|f
yuppie|m
zabalmedina|m
zalmedina|m
zapán|f
zarma|m
zasca|m
zayin|f
zayn|f
zelda|m
zeugma|m
zigapófisis|f
zika|m
zódiac|f
zombie|m
zoonosis|f
zoreja|m
zuña|m
`;

const PLURAL_DATA = `a|aes
abc|abcs
abdomen|abdómenes
accésit|accésit
acimut|acimuts
acromion|acrómiones
acuárium|acuáriums
acumen|acúmenes
adhan|adhans
adj.|adjs.
admón.|admones.
aducanumab|aducanumabs
adv.|advs.
ádyton|ádyton
aerobic|aerobics
aeróbic|aeróbics
aeropatín|aeropatínes
affidavit|affidavits
affidávit|affidávits
afidávit|afidávits
after|afters
afterhours|afterhours
aguarrás|aguarrás
airbag|airbags
alapívot|alapívots
albatros|albatroses
albumen|albúmenes
alcasínic|alcasíniques
alcotest|alcotest
alef|alefs
alien|aliens
álif|álifs
alprazolam|alprazolams
ampersand|ampersands
ángstrom|ángstroms
anorac|anoracs
anorak|anoraks
antepaís|antepaíses
anticlímax|anticlímax
antidoping|antidopings
ápex|ápex
apoyapiés|apoyapiés
app|apps
applet|applets
aquaplaning|aquaplanings
arahant|arahants
argot|argots
armañac|armañacs
armónium|armóniums
arquénteron|arquénteron
arráez|arraeces
auditórium|auditóriums
autoimagen|autoimágenes
automac|automac
autostop|autostops
axocopaque|axocopaque
ayto.|aytos.
azimut|azimuts
baby|babys
babyboomer|babyboomers
background|backgrounds
backlog|backlogs
bacon|bacons
baden|bádenes
bagel|bagels
baguet|baguets
bahman|báhmanes
baht|bahts
bait|baits
ballet|ballets
bandicut|bandicuts
banner|banners
baobab|baobabs
barn|barns
baronet|baronets
basidioliquen|basidiolíquenes
bastren|bástrenes
bat|bats
beefeater|beefeaters
beicon|béicones
béisment|béisments
besapiés|besapiés
bet|bet
bías|bías
bícep|bíceps
bíceps|bíceps
bidet|bidets
biker|bikers
bildungsroman|bildungsromans
biofilm|biofilms
biohacker|biohackers
biopic|biopics
bip|bips
birr|birrs
bísquet|bísquets
bistec|bistecs
bistrot|bistrots
bit|bits
bitcóin|bitcoines
bitumen|bitúmenes
blackjack|blackjacks
blackout|blackouts
bláster|blásters
blauet|blauets
bld|blds
bléiser|bléisers
blitz|blitz
bloc|blocs
blockbuster|blockbusters
blockchain|blockchains
blog|blogs
blogger|bloggers
blooper|bloopers
bluejeans|bluejeans
blues|blues
bluesman|bluesmen
bluf|blufs
blunt|blunts
bob|bobs
bobsleigh|bobsleighs
boicot|boicots
boiler|boilers
bolon|bólones
bols|bols
bookcrossing|bookcrossings
boom|booms
boomerang|boomerangs
booster|boosters
bórax|bórax
borscht|borschts
borshch|borshchs
bortsch|bortschs
borzoi|borzoi
bot|bots
botnet|botnets
bótox|bótox
bou|boues
boul|bouls
boulevard|boulevards
bourbon|bourbons
bowl|bowls
bowling|bowlings
boxer|boxers
bóxer|bóxers
boy|boys
boyband|boybands
bracket|brackets
braford|brafords
brahman|bráhmanes
brainrot|brainrots
brainstorming|brainstormings
bráket|brákets
branding|brandings
bráquet|bráquets
bratwurst|bratwurst
break|breaks
breakbeat|breakbeats
breck|brecks
briefing|briefings
brik|briks
broker|brokers
brother|brothers
brulot|brulots
brunch|brunchs
buffer|buffers
buffet|buffets
bug|bugs
buldog|buldogs
bulldog|bulldogs
bulldozer|bulldozers
bullpen|bullpens
bum|bums
búmeran|búmeran
bumerang|bumerangs
bumper|bumpers
bungalow|bungalows
bunker|bunkers
buquet|buquets
burger|burgers
burguer|burguers
burofax|burofax
bustier|bustiers
bypass|bypass
caban|cábanes
cabaret|cabarets
cachenez|cachenez
cacumen|cacúmenes
caderamen|caderámenes
caiquén|caiquénes
calientapiés|calientapiés
cambium|cambiums
cámbium|cámbiums
cambray|cambrais
camembert|camemberts
caminatour|caminatours
camping|campings
cámping|cámpings
canon|cánones
cantante-compositor|cantantes-compositores
canyac|canyacs
caos|caos
capoc|capocs
cárdigan|cárdigan
cardumen|cardúmenes
carjacking|carjackings
carmen|cármenes
carnet|carnets
carpool|carpools
carrulim|carrulims
cartoon|cartoons
cast|cast
castell|castells
castellana-leonesa|castellanas-leonesas
castin|cástines
casting|castings
cásting|cástings
catcher|catchers
cátcher|cátchers
catchup|catchups
cátchup|cátchups
cátering|cátering
catnip|catnips
caveat|caveats
cayac|cayacs
cazador-recolector|cazadores-recolectores
cbtis|cbtis
cdo.|cdos.
céfalon|cefalones
cemen|cémenes
cenit|cenits
cénit|cénits
cent|cents
center|centers
cepstrum|cepstrum
certamen|certámenes
cérvix|cérvix
cgd|cgds
chad|chads
chaebol|chaebols
chalet|chalets
chanson|chánsones
chârácter|châracteres
chardonnay|chardonnays
charleston|charlestons
chart|charts
chasís|chasís
chat|chats
chatbot|chatbots
chaty|chatys
chaulafan|chauláfanes
check|checks
check-in|check-ins
checkin|checkins
checkout|checkouts
cheddar|cheddars
chek|cheks
chengyu|chengyu
chickenwing|chickenwings
chiffonnier|chiffonniers
chiic|chiics
chip|chips
chipset|chipsets
chocochip|chocochips
chocomilk|chocomilks
choctaw|choctaw
cholet|cholets
chupachups|chupachups
chupachús|chupachús
chupistream|chupistreams
chut|chuts
chutney|chutneys
cibercrimen|cibercrímenes
ciborg|ciborgs
cíborg|cíborgs
ciclamen|ciclámenes
ciempiés|ciempiés
cientopiés|cientopiés
cinc|cincs
cineforum|cineforums
cinefórum|cinefórums
ciudad-estado|ciudades-estado
clac|claques
claxon|cláxones
clearing|clearings
clic|clics
click|clicks
climax|climax
clímax|clímax
clínex|clínex
clip|clips
closet|closets
clóset|clósets
cloud|clouds
clubbing|clubbings
cluster|clusters
coaching|coachings
coaster|coasters
cocarácter|cocaracteres
cóccix|cóccix
cock-tail|cock-tails
cockring|cockrings
cocktail|cocktails
coctail|coctails
códec|códecs
códex|códex
cofán|cofán
coheadliner|coheadliners
coktail|coktails
coktel|coktels
colab|colabs
colaless|colaless
colestasis|colestasises
colet|colets
colon|cólones
colt|colts
comelotodo|comelotodo
comic|comics
cómic|cómics
commodity|commoditys
complot|complots
compost|compost
coñac|coñacs
confort|conforts
connaisseur|connaisseurs
container|containers
contour|contours
contrafagot|contrafagots
contraorden|contraórdenes
coop|coops
cópec|cópecs
copín|copinos
copyleft|copylefts
copyright|copyrights
corion|córiones
corner|corners
correfoc|correfocs
corset|corsets
córtex|córtex
cosplay|cosplays
coulant|coulants
coulomb|coulomb
counter|counters
courier|couriers
courrier|courriers
cover|covers
cóver|cóvers
cowboy|cowboys
crac|cracs
crack|cracks
crak|craks
crew|crews
crimen|crímenes
cringe|cringe
criquet|criquets
crísum|crísum
crj|crjs
croac|croacs
croc|crocs
croissant|croissants
cromlech|cromlechs
crónlech|crónlech
cronut|cronuts
crooner|crooners
crossover|crossovers
croup|croups
crowdfunding|crowdfundings
crup|crups
ctvo.|ctvs.
cuadratrac|cuadratracs
cuádriceps|cuádriceps
cuark|cuarks
cúbit|cúbits
cubrecorset|cubrecorsets
cuc|cuc
cuck|cucks
cul-de-sac|cul-de-sacs
culamen|culámenes
culdesac|culdesacs
culmen|cúlmenes
cum|cums
currículum|currículum
curry|currys
currywurst|currywurst
cuscús|cuscús
cuuc|cuucs
cyberpunk|cyberpunks
cyberthriller|cyberthrillers
cyborg|cyborgs
dachshund|dachshunds
dahír|dahires
dálet|dálet
dancing|dancings
dandy|dandys
dcha.|dchas.
dealer|dealers
debut|debuts
default|defaults
déficit|déficits
delicatesen|delicatesens
delicatessen|delicatessens
dembow|dembows
desgravamen|desgravámenes
desmother|desmothers
desorden|desórdenes
détox|détox
diazepam|diazepams
dicdic|dicdics
dictamen|dictámenes
dictum|dictums
didjeridu|didjeridu
digipack|digipacks
diktat|diktats
dip|dips
dircom|dircoms
dírham|dírhams
display|displays
djinn|djinns
docurreality|docurreality
dogout|dogouts
dolmen|dólmenes
domain|domains
dominatrix|dominatrix
domp|domps
domplin|dómplines
dong|dongs
donut|donuts
dónut|dónuts
doorman|doormans
doping|dopings
downhill|downhills
draft|drafts
drag|drags
dub|dubs
dugout|dugouts
dullahan|dullahans
dumper|dumpers
dumpin|dumpins
dumping|dumpings
dúplex|dúplex
duralex|duralex
duramen|durámenes
durian|durians
dux|dux
ebook|ebooks
ectocérvix|ectocérvix
efrit|efrits
ekuele|bikuele
ekuk|ekuks
eland|elands
electroshock|electroshocks
email|emails
emoticon|emoticons
engagement|engagements
épsilon|épsilon
erg|ergs
esavi|esavi
escólex|escólex
eslalon|eslálones
esmoquin|esmóquines
esnorkeling|esnorkelings
espécimen|especímenes
esplenitis|esplenites
espray|espráis
estadity|estadities
estand|estands
estent|estents
et|ets
examen|exámenes
exâmen|exámenes
exclub|exclubs
exequatur|exequatur
exequátur|exequátur
exmánager|exmánagers
exonártex|exonártex
exprés|exprés
expresident|expresidents
extranet|extranets
fa|fa
facelock|facelocks
factoring|factorings
falciparum|falciparums
fandom|fandoms
fanfic|fanfics
fánfic|fánfics
fanshop|fanshops
faralá|faralaes
fárting|fártings
fatum|fatums
fátum|fátums
fax|fax
feed|feeds
feedback|feedbacks
feeling|feelings
femboy|femboys
fénec|fénecs
fenghuang|fenghuangs
fénix|fénix
fernet|fernets
fi|fíes
film|films
firewall|firewalls
firuláis|firulaises
flageolet|flageolets
flap|flaps
flash-back|flash-backs
flashback|flashbacks
flashmob|flashmobs
flashpot|flashpots
flisflís|flisflís
flog|flogs
flow|flows
foam|foams
foilboard|foilboards
folder|folders
fondac|fondacs
fondant|fondants
foramen|forámenes
fórceps|fórceps
forfait|forfaits
forminx|forminx
fórnix|fórnix
forum|forums
fórum|fórums
fotoblog|fotoblogs
fotolog|fotologs
foulard|foulards
foxtrot|foxtrots
friend|friends
frikirap|frikiraps
fuagrás|fuagrás
fuet|fuets
full|full
gadget|gadgets
gag|gags
gameplay|gameplays
gang|gangs
gap|gaps
gaur|gaurs
gens|gens
gentleman|gentlémanes
geoduck|geoducks
germen|gérmenes
geyser|geysers
gif|gifs
gigabit|gigabits
ginseng|ginsengs
gintonic|gintonics
gintónic|gintónics
glam|glams
glásnost|glásnost
glicocálix|glicocálix
gluten|glútenes
godet|godets
golden|golden
golem|golems
gólem|gólems
goliat|goliats
gomet|gomets
goming|gomings
gong|gongs
granpin|gránpines
gravamen|gravámenes
grill|grills
grombif|grombifs
guardarraíl|guardarrailes
guasap|guasaps
guásap|guásaps
gúgolplex|gúgolplex
guiffity|guiffitys
guímel|guímel
gulag|gulags
gym|gyms
gyr|gyrs
hach|hach
hackathon|hackathons
halibut|halibuts
hall|halls
hallux|hallux
hamam|hamams
hamburger|hamburgers
hamster|hamsters
handicap|handicaps
hándicap|hándicaps
handisport|handisports
hápax|hápax
happening|happenings
hashtag|hashtags
hastag|hastags
hat-trick|hat-tricks
hatchback|hatchbacks
hdp|hdp
headliner|headliners
headscissors|headscissors
heater|heaters
hemitórax|hemitórax
hemotórax|hemotórax
hersir|hersir
hertz|hertz
hidrojet|hidrojets
highlight|highlights
hijadalgo|hijasdalgo
himen|hímenes
hipervolumen|hipervolúmenes
hippy|hippys
hit|hits
hiyab|hiyabs
hna.|hnas.
hobbit|hobbits
hobby|hobbys
hockey|hockey
hold|holds
holding|holdings
hólding|hóldings
holdout|holdouts
homelet|homelets
host|host
hotdog|hotdogs
hotspot|hotspots
hoyatoleslam|hoyatoleslams
hub|hubs
huevín|huevinos
husky|huskys
hutspot|hutspots
hybris|hybris
i|íes
ibex|ibex
iceberg|icebergs
identikit|identikits
ifrit|ifrits
íleon|íleon
imagen|imágenes
imatinib|imatinibs
impeachment|impeachments
imprimátur|imprimátur
inbox|inbox
íncipit|íncipits
índex|índex
infield|infields
infielder|infielders
infraorden|infraórdenes
inning|innings
input|inputs
inselberg|inselbergs
intercom|intercoms
interes|intereses
interfon|interfon
ínterim|ínterims
intranet|intranets
ípsilon|ípsilon
isquion|ísquiones
jab|jabs
jackfruit|jackfruits
jailbreak|jailbreaks
jazzband|jazzbands
jean|jeans
jeans|jeans
jeep|jeeps
jersey|jerséis
jet|jets
ji|jíes
jinn|jinns
jit|jits
jíter|jíters
joystick|joysticks
jumpsuit|jumpsuits
kadish|kadish
kalashnikov|kalashnikov
kaláshnikov|kaláshnikovs
karcher|karchers
kart|karts
kayac|kayacs
kayak|kayaks
kebab|kebabs
kelp|kelps
kelvin|kelvins
kérex|kérex
ketchup|ketchups
kibbutz|kibbutz
kibutz|kibutz
kill|kills
kilowatt|kilowatts
kínder|kínders
kindergarten|kindergartens
kinilaw|kinilaws
kit|kits
kiteboard|kiteboards
kleenex|kleenex
klinex|klinex
klingon|klingon
know-how|know-hows
knut|knut
kopek|kopeks
kópek|kópeks
kril|kril
kuchen|kúchenes
kumquat|kumquats
lab|labs
lady|ladies
land|lands
lasix|lasix
leberwurst|leberwurst
lemming|lemmings
leprechaun|leprechauns
lic|lics
lifting|liftings
ligamen|ligámenes
limen|límenes
linebacker|linebackers
lineup|lineups
link|links
linkbuilding|linkbuildings
lipstick|lipsticks
liquen|líquenes
listening|listenings
living|livings
lobby|lobbies
locker|lockers
locus|loci
loden|lódenes
loft|lofts
loly|lolys
lolly|lollys
longan|lónganes
look|looks
lorazepam|lorazepams
lord|lores
lumen|lúmenes
lumpen|lúmpenes
lúrex|lúrex
lux|lux
macaron|macarons
maderamen|maderámenes
mágnetar|mágnetar
mágnum|mágnums
magret|magrets
mahout|mahouts
maid|maids
mailing|mailings
maillot|maillots
mainstream|mainstreams
maison|maisons
major|majors
making-of|making-of
mall|malls
malpaís|malpaíses
mamut|mamuts
management|managements
mapping|mappings
maquilishuat|maquilishuats
marcen|márcenes
maremágnum|maremágnums
marketing|marketings
marshmallow|marshmallows
marxismo-leninismo|marxismos-leninismos
master-class|master-class
mat|mats
matkot|matkots
máximum|máximum
mayús|mayús
mcd|mcds
mcm|mcms
medley|medleys
meeting|meetings
meetup|meetups
megabit|megabits
megacolon|megacólones
megacomplot|megacomplots
megashow|megashows
méijor|méijors
meldonium|meldoniums
memorándum|memorándums
men|men
merchandising|merchandisings
merlot|merlots
mesocolon|mesocólones
mesotórax|mesotórax
metatórax|metatórax
mi3rd@|mi3rd@s
miao|miao
microblog|microblogs
microbus|microbuses
microchip|microchips
microcómic|microcómics
microfilm|microfilms
microhábitat|microhábitats
microjet|microjets
microrrobot|microrrobots
milord|milores
milpiés|milpiés
miniálbum|miniálbums
minibús|minibús
miniclub|miniclubs
minigolf|minigolfs
minilaptop|minilaptops
mínimum|mínimum
minipimer|minipimers
minishort|minishorts
minivan|minivans
minor|minors
minuet|minuets
mitin|mítines
mitzvá|mitzvot
mix|mix
mm|mms
mmd|mmds
mod|mods
modem|modems
módem|módems
mohawk|mohawks
mohín|mohínes
moisés|moisés
monovolumen|monovolúmenes
montelukast|montelukast
mosfet|mosfets
motocart|motocarts
mp3|mp3s
mrd|mrds
mrk|mrks
mu|múes
muak|muaks
mukluk|mukluks
multikirolak|multikirolaks
muslamen|muslámenes
mustang|mustangs
muzak|muzaks
naam|naams
nanoplancton|nanoplánctones
nanorrobot|nanorrobots
narcorrégimen|narcorregímenes
narcotest|narcotest
nártex|nártex
negus|neguses
neocórtex|neocórtex
net|nets
netbook|netbooks
neumotórax|neumotórax
neuroimagen|neuroimágenes
newton|newton
ni|níes
nínox|nínox
niqab|niqabs
nobel|nobel
nocaut|nocauts
notebook|notebooks
nugget|nuggets
núm|núms
numen|númenes
ny|nys
o|oes
óblast|óblast
offset|offsets
ófset|ófsets
ohm|ohms
ókrug|ókrugs
olécranon|olecranones
óleum|óleums
omelet|omelets
oncidium|oncidiums
onsen|onsens
oobleck|ooblecks
oolong|oolongs
opening|openings
origen|orígenes
orijen|oríjenes
otherkin|otherkin
out|outs
outfielder|outfielders
outfit|outfits
outlet|outlets
output|output
p.|pp.
pack|packs
paddock|paddocks
padyak|padyaks
pág|págs
pailebot|pailebots
país|países
palet|palets
pálet|pálets
pallet|pallets
pandemónium|pandemóniums
panty|pantys
papadum|papadums
papalometl|papalometls
paper|papers
parenting|parentings
parking|parkings
párking|párkings
parquet|parquets
parsec|parsecs
pársec|pársecs
pasapurés|pasapurés
password|passwords
patchwork|patchworks
patriarchâ|patriarchâs
pavíl|paviles
pay|pays
pcr|pcr
peeling|peelings
pellet|pellets
pen|pens
pendentif|pendentifs
penetron|penétrones
peplum|peplums
péplum|péplums
perjumen|perjúmenes
petipuá|petipuá
petipuás|petipuás
petrodiésel|petrodiésel
phablet|phablets
photobomb|photobombs
photoshop|photoshops
pi|píes
picnic|picnics
pícnic|pícnics
picoplancton|picoplánctones
piercing|piercings
pierogi|pierogi
pilsen|pílsenes
pinball|pinballs
pindari|pindari
ping|pings
piolet|piolets
pirsin|pírsines
pitbull|pitbulls
pitcher|pitchers
pivot|pivots
plácet|plácets
planing|planings
playback|playbacks
playboy|playboys
playlist|playlist
playoff|playoffs
plg|plgs
plot|plots
plugin|plugins
pluot|pluots
podium|podiums
pódium|pódiums
poison|póisones
póker|pókers
polen|pólenes
poliban|polibans
poliforum|poliforums
poliptoton|poliptótones
políptoton|políptoton
pómez|pómez
pony|ponys
pop|pops
popcorn|popcorns
popper|poppers
portabebés|portabebés
pósit|pósits
post-it|post-its
postdoc|postdocs
postmortem|postmortems
postorden|postórdenes
pósum|pósums
powerpoint|powerpoints
precrimen|precrímenes
predict|predicts
preimagen|preimágenes
premium|premiums
prémium|prémiums
premortem|premortems
preorden|preórdenes
president|presidents
presídium|presídiums
prest|prest
proctoring|proctorings
prompt|prompts
protórax|protórax
prozac|prozac
psi|psíes
psoas|psoas
pub|pubs
pudding|puddings
puf|pufs
pujamen|pujámenes
punk|punks
punsch|punschs
puntocom|puntocom
put|puts
puticlub|puticlubs
ql|qls
qq|qq
quad|quads
quantum|quanta
quántum|quanta
quark|quarks
quarterback|quarterbacks
quasar|quasars
qubit|qubits
quídam|quídams
quiz|quizzes
rack|racks
rácord|rácords
radium|radiums
rádium|rádiums
ragebait|ragebaits
raiting|raitings
rajput|rajput
rally|rallys
random|randoms
rándom|rándoms
rankin|ránkines
ranking|rankings
ránking|ránkings
ranquin|ránquines
rap|raps
rappel|rappels
rating|ratings
ráting|rátings
reading|readings
record|records
récord|récords
récordman|récordman
redbanc|redbancs
reexamen|reexámenes
referéndum|referéndums
réflex|réflex
régimen|regímenes
rémix|rémix
render|renders
renting|rentings
repelús|repelús
reposapiés|reposapiés
réquiem|réquiems
reset|resets
resort|resorts
resumen|resúmenes
retuit|retuits
retweet|retweets
reverb|reverbs
revolú|revoluces
rickshaw|rickshaws
riff|riffs
right|rights
ring|rings
ringgit|ringgits
rituximab|rituximabs
roadster|roadsters
roaming|roamings
robocop|robocops
robot|robots
rock|rocks
rockabilly|rockabillys
rolin|rólines
romcom|romcoms
roquefort|roqueforts
rosbif|rosbifs
round|rounds
router|routers
rugbier|rugbiers
rugby|rugbys
rumen|rúmenes
runabout|runabouts
rus|rus
sachet|sachets
sah|sah
saín|saínes
salabat|salabats
sambusek|sambuseks
sandboard|sandboards
sarakof|sarakofs
sarong|sarongs
scanner|scanners
schop|schops
scoop|scoops
scouting|scoutings
scrach|scrach
scratch|scratchs
screenshot|screenshots
script|scripts
scroll|scrolls
semen|sémenes
septum|septums
sérum|sérums
server|servers
set|sets
shalágram|shalágram
shamisen|shamísenes
shantung|shantungs
sherif|sherifs
sheriff|sheriffs
ship|ships
shitake|shitake
shock|shocks
shoegazing|shoegazings
shop|shops
shopping|shoppings
short|shorts
shortstop|shortstops
shot|shots
show|shows
showroom|showrooms
sicav|sicavs
sievert|sieverts
siévert|siéverts
sílex|sílex
símplex|símplex
simposium|simposiums
simpósium|simpósiums
sitcom|sitcoms
skateboard|skateboards
skatebord|skatebords
skimboard|skimboards
skin|skins
slang|slangs
slap|slaps
slasher|slashers
slip|slip
slogan|slogans
slump|slumps
smartwatch|smartwatchs
smog|smogs
smoking|smokings
sms|sms
snack|snacks
snap|snaps
snob|snobs
snuff|snuffs
solárium|soláriums
soulman|soulmen
soundtrack|soundtracks
soutien|soutiens
souvenir|souvenirs
soviet|soviets
sóviet|sóviets
spam|spams
speaking|speakings
spinoff|spinoffs
sport|sports
spot|spots
sprint|sprints
squat|squats
squirt|squirts
stablishment|stablishments
staff|staffs
stand|stands
standing|standings
start-up|start-ups
startup|startups
stent|stents
still|stills
stock|stocks
storyboard|storyboards
stout|stouts
stream|streams
streaming|streamings
stylus|stylus
suborden|subórdenes
summum|summums
sunorma|sunormales
sunormá|sunormales
sunroof|sunroofs
superavit|superavits
superávit|superávits
superorden|superórdenes
supervip|supervips
sust.|susts.
swap|swaps
swing|swings
tac|tacs
tac-tac|tac-tacs
tailleur|tailleurs
talaq|talaq
talayot|talayots
talit|talitot
tampax|tampax
tandem|tandems
tándem|tándems
tandoor|tandoor
taoiseach|taoiseachs
tapersex|tapersex
target|targets
tarot|tarots
taxon|táxones
teff|teffs
tel.|tels.
telefilm|telefilms
telepromter|telepromters
teletac|teletacs
télex|télex
tell|tells
tenasmon|tenásmones
terabit|terabits
terafim|terafim
teraflop|teraflops
tetamen|tetámenes
tetrabrik|tetrabriks
theremin|therémines
thinner|thinners
tía-abuela|tías-abuelas
tic|tics
tic-tac|tic-tacs
tick|ticks
ticket|tickets
tictac|tictacs
tiebreak|tiebreaks
tiktok|tiktoks
timol|timol
tip|tips
tipex|tipex
típex|típex
tippex|tippex
tíquet|tíquets
token|tókenes
tomboy|tomboys
toner|toners
tony|tonys
top|tops
tóper|tópers
topping|toppings
tórax|tórax
tornatrás|tornatrás
tory|torys
totem|totems
tótem|tótems
touchdown|touchdowns
tour|tours
touring|tourings
track|tracks
trading|tradings
trailer|trailers
training|trainings
transcript|transcripts
trastuzumab|trastuzumabs
traumen|tráumenes
travelling|travellings
trekking|trekkings
trenchcoat|trenchcoats
triceps|triceps
tríceps|tríceps
tricot|tricots
tricotrí|tricotrís
trip|trips
tríplex|tríplex
tris|tris
trust|trust
tryout|tryouts
tuit|tuits
tumblr|tumblrs
tupper-sex|tupper-sex
tuppersex|tuppersex
turf|turfs
tuya-mía|tuya-mía
tweet|tweets
twerking|twerkings
twist|twist
twit|twits
ultratrail|ultratrails
umrah|umrahs
unboxing|unboxings
underground|undergrounds
unimoc|unimocs
uromástix|uromástix
utility|utilitys
v4cun4|v4cun4s
vacuum|vacuums
vademécum|vademécums
val|valles
valet|valets
vaporetto|vaporetti
vasín|vasinos
vav|vav
vejamen|vejámenes
velamen|velámenes
vergobret|vergobrets
vermut|vermuts
vg|vgs
videoblog|videoblogs
videochat|videochats
videoclip|videoclips
vídeoclip|vídeoclips
videomapping|videomappings
viking|vikings
víking|víkings
vinín|vininos
vítrex|vítrex
vivac|vivaques
vodník|vodníci
volumen|volúmenes
vórtex|vórtex
vrd|vrds
vrg|vrgs
walkman|walkman
wampanoag|wampanoags
was|was
wasap|wasaps
wásap|wásaps
water|waters
wáter-closet|wáter-closets
watt|watts
wbd|wbds
webcam|webcams
webcast|webcast
webcómic|webcómics
weber|webers
weblog|weblogs
webshow|webshows
wergild|wergilds
western|westerns
wéstern|wésterns
whatsapp|whatsapps
whisky|whiskys
whopper|whoppers
widget|widgets
wildcard|wildcards
windsurfing|windsurfings
wingsuit|wingsuits
wok|woks
workshop|workshops
wrap|wraps
writing|writings
xapones|xaponeses
xi|xíes
xuc|xucs
yac|yacs
yachak|yachak
yagurt|yagurts
yérsey|yerseis
yinn|yinn
yinyang|yinyangs
yoghourt|yoghourts
yoghurt|yoghurts
yogourt|yogourts
yogurt|yogurts
yokai|yokai
yuppy|yuppys
zapping|zappings
zarévich|zarévich
zayin|zayin
zayn|zayn
zenit|zenits
zénit|zénits
zig-zag|zig-zags
zigurat|zigurats
zinc|zincs
zip|zips
zloty|zlotys
zodiac|zodiacs
zódiac|zódiacs
zoom|zooms
zum|zums
`;

/** Nouns whose gender contradicts what their ending suggests. */
export const GENDERS: ReadonlyMap<string, "masculine" | "feminine"> = new Map(
  GENDER_DATA.split("\n")
    .filter((line) => line.length > 0)
    .map((line) => {
      const [lemma, gender] = line.split("|") as [string, string];
      return [lemma, gender === "f" ? "feminine" : "masculine"] as const;
    }),
);

/** Nouns whose plural the spelling rules do not produce. */
export const PLURALS: ReadonlyMap<string, string> = new Map(
  PLURAL_DATA.split("\n")
    .filter((line) => line.length > 0)
    .map((line) => line.split("|") as [string, string]),
);
